import { Messages } from '../../codegen/Localize';
import { CommonErrorCode, ProjectErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { IProjectBase } from '../models/IProjectInfo';
import { Module } from '../Module';
import { Projects } from '../resources/Projects';
import { IError } from '../ServerApi/types/IError';
import { IResult } from '../ServerApi/types/IResponse';
import { ToasterService, ToastType } from './ToasterService';

export class ChangeProjectDescriptionAction {

  public static $inject = ['$translate', 'Projects'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private Projects: Projects) { }

  public execute(project: IProjectBase, newDescription: string): ng.IPromise<IResult> {

    return this.Projects.setDescription(project.id, newDescription).then((result: IResult) => {
      if (result.errors && result.errors.length) {
        ToasterService.instance.pop({ type: ToastType.Error, text: this.errorMessageFor(result.errors[0], project) });
      } else {
        ToasterService.instance.pop({ type: ToastType.Info, text: Messages.editDescriptionSuccessful() });
      }
      return result;
    });

  }

  private errorMessageFor(error: IError, project: IProjectBase) {
    switch (error.code) {
      case ProjectErrorCode.ProjectDescriptionGreaterThanMaxLength:
        return this.$translate.instant('errorProjectDescriptionTooLong');
      case CommonErrorCode.ProjectNotFound:
        return this.$translate.instant('errorProjectNotFound', { PROJECT_NAME: L10n.elideIfLong(project.name) });
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('ChangeProjectDescriptionAction', ChangeProjectDescriptionAction);
